// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"modalFooter_modalFooter__3kpux"};